export default __webpack_public_path__ + "static/media/globo-mais-cor.bf3154ec.png";